export default "__VITE_ASSET__dece8c76__"